export const TIPO_RELATORIO_RGF = "02";
export const TIPO_MEIO_DIARIO_OFICIAL_ESTADO = "06";

export function encerraQuadrimestreDpge(bimestre) {
    return [2, 4, 6].includes(Number(bimestre));
}

export function janelaPublicacaoRgfDpge(ano, bimestre) {
    const anoNumerico = Number(ano);
    const periodo = Number(bimestre);
    if (
        !/^\d{4}$/.test(`${ano}`) ||
        !Number.isInteger(anoNumerico) ||
        !encerraQuadrimestreDpge(periodo)
    ) {
        return null;
    }

    const dataMinima = new Date(anoNumerico, periodo * 2, 0);
    const dataMaxima = new Date(dataMinima);
    dataMaxima.setDate(dataMaxima.getDate() + 30);

    return {
        dataMinima: formatarDataIso(dataMinima),
        dataMaxima: formatarDataIso(dataMaxima)
    };
}

export function dataPublicacaoRgfValida(ano, bimestre, dataPublicacao) {
    const janela = janelaPublicacaoRgfDpge(ano, bimestre);
    return Boolean(
        janela &&
            /^\d{4}-\d{2}-\d{2}$/.test(dataPublicacao) &&
            dataPublicacao >= janela.dataMinima &&
            dataPublicacao <= janela.dataMaxima
    );
}

export function anexosRgfDpge(bimestre) {
    const periodo = Number(bimestre);
    if (periodo === 2 || periodo === 4) {
        return [1];
    }
    if (periodo === 6) {
        return [1, 5, 6];
    }
    return [];
}

export function descricaoAnexosRgfDpge(bimestre) {
    const anexos = anexosRgfDpge(bimestre);
    if (anexos.length === 0) {
        return "sem publicação de RGF";
    }
    return anexos.map((numero) => `Anexo ${numero}`).join(", ");
}

function formatarDataIso(data) {
    const ano = `${data.getFullYear()}`.padStart(4, "0");
    const mes = `${data.getMonth() + 1}`.padStart(2, "0");
    const dia = `${data.getDate()}`.padStart(2, "0");
    return `${ano}-${mes}-${dia}`;
}
